import React from "react";
import HeaderCompNew from "./shares/newHeaderComp";
import CommonButtonNew from "./shares/newCommonButton";

const CancellationScreenComp = ({ createStripePayment = () => {} }) => {
   const navigateHomeFun = () => {
      localStorage.removeItem("showTrialButton");
      localStorage.setItem("trialEndedRedirection", "true");
      window.location.href = "/notes";
   };

   const showStartTrial = !(localStorage.getItem("showTrialButton") === "true");
   const text = {
      title: "Your payment was unsuccessful",
      para: showStartTrial
         ? "We’re sorry, but your payment could not be processed. Please try again - or start your free trial!"
         : "We’re sorry, but your payment could not be processed",
   };

   return (
      <div className="pg-final-aline-container-failuer-new-ui px-4 d-relative">
         <div style={{ marginBottom: "52px" }}>
            <HeaderCompNew text={text} isDone={true} showStartTrial={showStartTrial} />
         </div>
         <div className="pg-button-container-new-ui">
            <div>
               <CommonButtonNew
                  id="retry-button"
                  btnText={showStartTrial ? "Start 14-day Free Trial" : "Back to Home"}
                  onClick={navigateHomeFun}
                  loading={false}
                  isbuttonWidth={true}
                  buttonWidth="316px"
               />
            </div>
            <CommonButtonNew
               id="retry-button"
               btnText="Retry Payment"
               onClick={createStripePayment}
               loading={false}
               isWhiteBtn={true}
               isbuttonWidth={true}
               buttonWidth="316px"
            />
         </div>
      </div>
   );
};

export default CancellationScreenComp;
